import React from 'react';
import { useEffect, useState, useContext, useCallback } from 'react';
import axios from 'axios';
import { AuthContext } from '../ContextAuth/Context';
import { Table } from '../TradeCurrency/Table';
import { Column } from './Columns';
import { SeeAll } from '../Components/SeeAll';
import { getToken } from '../utils';

export const Ratings = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [ratings, setRatings] = useState(false);
  const { token: userToken } = getToken();

  const ratingTableData = [
    {
      id: 1,
      date: '17 May, 23',
      currency: 'USD',
      type: 'Buy',
      ratings: 2.5,
      feedback: 'Good',
      user: 'Xydgrjhj',
    },
    {
      id: 1,
      date: '17 May, 23',
      currency: 'USD',
      type: 'Buy',
      ratings: 2.5,
      feedback: 'Good',
      user: 'Xydgrjhj',
    },
    {
      id: 1,
      date: '17 May, 23',
      currency: 'USD',
      type: 'Buy',
      ratings: 2.5,
      feedback: 'Good',
      user: 'Xydgrjhj',
    },
  ];

  useEffect(() => {
    setIsLoading(!isLoading);
    const getBuyOffers = async () => {
      try {
        const response = await axios.get(
          'https://apex.loyaltyview.com/api/rating/my-ratings',

          {
            headers: { Authorization: `Bearer ${userToken}` },
          }
        );
        console.log(response.data);
        setRatings(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    getBuyOffers();
    setIsLoading(isLoading);

    // return () => {
    //   second
    //  }
  }, [userToken]);

  return (
    <div className='flex flex-col gap-8 mt-8 mx-6'>
      <SeeAll name='Ratings' seeAll={false} />
      <Table columns={Column} data={ratingTableData} />
    </div>
  );
};
